

// Function to set a custom date for testing
function setCustomDate(year, month, day, hours, minutes) {
  const customDate = new Date();
  customDate.setFullYear(year, month - 1, day);
  customDate.setHours(hours || 0, minutes || 0, 0, 0);
  return customDate;
}

// Example test scenario
const testDate = setCustomDate(2024, 4, 19, 17, 29);

const currentDate = new Date(); // Use the actual current date
// const currentDate = testDate; // Use a custom date for testing purposes

formatDate = (date) => {
  const formatWithLeadingZero = (value) => (value < 10 ? '0' : '') + value;
  return `${formatWithLeadingZero(date.getDate())}.${formatWithLeadingZero(
    date.getMonth() + 1
  )}.${date.getFullYear()}`;
};

// Custom HTML element
class DeliveryDate extends HTMLElement {
  connectedCallback() {
    this.calculateDeliveryDate();
  }

  calculateDeliveryDate() {
    const { earliestDate, latestDate } = this.calculateDeliveryDateRange(currentDate);
    const deliveryText = this.getAttribute('delivery-text');
    this.innerText = `${deliveryText}${earliestDate} - ${latestDate}`;
  }

  
  isWeekend = (date) => date.getDay() === 0;

  // Delivery date calculation function
  calculateDeliveryDateRange = (currentDate) => {
    const deliveryDate = new Date(currentDate);
    const isAfter1PM = currentDate.getUTCHours() >= 12;

    // Set the delivery date based on the time
    if (isAfter1PM) {
      deliveryDate.setDate(currentDate.getDate() + 2);
    } else {
      deliveryDate.setDate(currentDate.getDate() + 1);
    }

    // Move delivery date to the next day if it falls on a weekend
    if (this.isWeekend(deliveryDate)) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
    }

    const earliestDate = new Date(deliveryDate);
    let latestDate = new Date(deliveryDate);
    latestDate.setDate(latestDate.getDate() + 2);

    // Adjust the latest date if it or the day between earliest and latest is a weekend
    if (this.isWeekend(latestDate) || this.isWeekend(new Date(latestDate.getTime() - 86400000))) {
      latestDate.setDate(latestDate.getDate() + 1);
    }

    return {
      earliestDate: formatDate(earliestDate),
      latestDate: formatDate(latestDate),
    };
  };

}

customElements.define('delivery-date', DeliveryDate);



// German translations for flatpickr library
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.de = {}));
}(this, (function (exports) { 'use strict';

  var fp = typeof window !== "undefined" && window.flatpickr !== undefined
      ? window.flatpickr
      : {
          l10ns: {},
      };
  var German = {
      weekdays: {
          shorthand: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
          longhand: [
              "Sonntag",
              "Montag",
              "Dienstag",
              "Mittwoch",
              "Donnerstag",
              "Freitag",
              "Samstag",
          ],
      },
      months: {
          shorthand: [
              "Jan",
              "Feb",
              "Mär",
              "Apr",
              "Mai",
              "Jun",
              "Jul",
              "Aug",
              "Sep",
              "Okt",
              "Nov",
              "Dez",
          ],
          longhand: [
              "Januar",
              "Februar",
              "März",
              "April",
              "Mai",
              "Juni",
              "Juli",
              "August",
              "September",
              "Oktober",
              "November",
              "Dezember",
          ],
      },
      firstDayOfWeek: 1,
      weekAbbreviation: "KW",
      rangeSeparator: " bis ",
      scrollTitle: "Zum Ändern scrollen",
      toggleTitle: "Zum Umschalten klicken",
      time_24hr: true,
  };
  fp.l10ns.de = German;
  var de = fp.l10ns;

  exports.German = German;
  exports.default = de;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
if (Shopify && Shopify.locale) {
  if (Shopify.locale == 'de') flatpickr.localize(flatpickr.l10ns.de);
}
else {
  flatpickr.localize(flatpickr.l10ns.de);
}

class DeliveryCalendar extends HTMLElement {
  async connectedCallback() {
    const currentUTC = new Date(Date.UTC(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 9, 0, 0));

    // Set min date to after 2 if it's after 9 AM UTC
    const minDate = currentDate.getUTCHours() >= 9 ? this.addDays(currentUTC, 2) : this.addDays(currentUTC, 1);

    // Get cancel and confirm buttons
    let cancelButton = this.querySelector('.cancel-btn');
    let confirmButton = this.querySelector('.confirm-btn');
    this.removeLink = document.querySelector('#remove-delivery')

    // Get product data
    let dateProduct = this.getProductData();

    // Set max date to 14 days from now
    const maxDate = this.addDays(currentDate, 180);
    const dateInput = this.querySelector('input#selectedDate');

    this.opener = this.querySelector("#calendar-opener")

    // Initialize flatpickr
    this.instance = flatpickr(dateInput, {
      minDate: minDate,
      maxDate: maxDate,
      animate: false,
      monthSelectorType: "static",
      disable: [
        function (date) {
          // Disable Sundays
          return date.getDay() === 0;
        }
      ],
      onReady: async (selectedDates, dateStr, instance) => {
        const calendarContainer = instance.calendarContainer;
        const calendarFooter = this.querySelector("#calendar-footer");
        const calendarHeader = this.querySelector("#calendar-header");
        calendarContainer.prepend(calendarHeader);
        calendarContainer.appendChild(calendarFooter);
        // Reassign buttons after appending to the DOM
        cancelButton = calendarFooter.querySelector('.cancel-btn');
        confirmButton = calendarFooter.querySelector('.confirm-btn');

      },
      onOpen: function (instance) {
        document.documentElement.classList.add("no-scroll");
        document.getElementById('overlay').style.display = 'block';
      },
      onClose: function (params) {
        document.documentElement.classList.remove("no-scroll");
        document.getElementById('overlay').style.display = 'none';
      },
      onChange: function (selectedDates, dateStr, instance) {
        // Open the calendar and enable the confirm button
        instance.open();
        confirmButton.removeAttribute("disabled");
      }
    });
    this.opener.addEventListener('click', (event) => {
      event.preventDefault();
      this.instance.toggle()
    });

    const cartData = await this.fetchCartData();

    this.hasDeliveryAttribute();
    this.isDateProductInCart(cartData, dateProduct)
    // Check if cart has attribute and dateProduct is in the cart 
    document.addEventListener('cart:updated', (evt) => {
      console.log(evt.detail.cart);
      this.hasDeliveryAttribute();
      this.isDateProductInCart(evt.detail.cart, dateProduct);
    });
  

    // Add event listeners for button clicks
    cancelButton.addEventListener('click', () => this.cancelButtonClick());
    confirmButton.addEventListener('click', () => this.confirmButtonClick(confirmButton, dateProduct));
    this.removeLink.addEventListener('click', () => this.removeDateItem(event));
  }

  async removeDateItem(event) {
    // this.updateDateAttribute()
    // this.hideDateInCart()
  }

  getProductData() {
    // Retrieve and parse product data
    let dataEl = this.querySelector('[data-delivery-product]');
    let data = JSON.parse(dataEl.innerHTML);
    data = data[0];
    return data;
  }

  cancelButtonClick() {
    // Reset the date to the initial value and close the calendar
    this.instance.setDate(null);
    this.instance.close();
  }

  async confirmButtonClick(confirmButton, dateProduct) {
    // Get the selected date
    const selectedDate = this.instance.selectedDates[0];

    var fomattedSelectedDate = formatDate(selectedDate);
    this.addDateProductInCart(dateProduct, fomattedSelectedDate)

    const cartData = await this.fetchCartData();

    await this.isDateProductInCart(cartData, dateProduct);
    this.showDateInCart(fomattedSelectedDate)
    this.instance.close();
  }

  async hasDeliveryAttribute() {
    const cartData = await this.fetchCartData();
    if (cartData.attributes["Date"]) {
      return true
    }
  }


  showDateInCart(selectedDate) {
    document.querySelector(".delivery-estimate").querySelector(".estimated-text").classList.add("hidden");
    document.querySelector(".delivery-estimate").querySelector(".selected-delivery").classList.remove("hidden");
    document.querySelector('.selected-date').innerText = selectedDate;
  }
  hideDateInCart() {
    document.querySelector(".delivery-estimate").querySelector(".estimated-text").classList.remove("hidden");
    document.querySelector(".delivery-estimate").querySelector(".selected-delivery").classList.add("hidden");
  }


  async fetchCartData() {
    const response = await fetch(theme.routes.cart);
    const cartData = await response.json();
    return cartData;
  }

  updateDateAttribute(attributeValue) {
    var formData = new FormData();
    formData.append("attributes[Date]", attributeValue || '' );
    fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
    })
    .then(response => response.json())
    .then(data => {return data});
}

  async addDateProductInCart(dateProduct, selectedDate) {
    const cartData = await this.fetchCartData();
    const existingItem = cartData.items.find(item => item.id === dateProduct.id);

  if (existingItem) {
      // Update the existing item with the new property
      existingItem.properties.Date = selectedDate;

      // Perform the fetch request to update the cart with the modified item
      await fetch(`${theme.routes.cartChangeLink}?id=${existingItem.id}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(existingItem)
      });
      this.updateDateAttribute(selectedDate);

      // Reload the page or update the cart as needed
      // window.location.reload(); // Reload the page
      // Or dispatch a custom event to update the cart
      document.dispatchEvent(new CustomEvent('cart:build'));
  } else {
    // Prepare data for the fetch request
    var formBody = {
      items: [{
        'id': dateProduct.id,
        'quantity': 1,
        'properties': {
          'Date': selectedDate,
        }
      }],
      attributes: {
        "Date": selectedDate,
      }
    };

    // Perform the fetch request to update the cart
    const itemCart = await fetch(theme.routes.cartAdd, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formBody)
    })
      .then(async response => {
        // Dispatch a custom event to update the cart
        await this.isDateProductInCart(await this.fetchCartData(), dateProduct);
        document.dispatchEvent(new CustomEvent('cart:build'));
        return response.json();
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    this.removeLink.setAttribute("href", `${theme.routes.cartChangeLink}?id=${itemCart.items[0].id}&quantity=0`)
    window.location.reload();

    }
  }

  async isDateProductInCart(cartData, dateProduct) {
    const itemsWithSameId = cartData.items.filter((item) => item.id === dateProduct.id);


    if (itemsWithSameId.length > 0) {

      // Remove all except the last item with the same id in the cart
      for (let i = 0; i < itemsWithSameId.length - 1; i++) {
        await theme.cart.changeItem(itemsWithSameId[i].key, 0);
      }
      document.dispatchEvent(new CustomEvent('cart:build'));


      // If the last item's quantity is greater than 1, adjust the quantity to 1
      if (itemsWithSameId[itemsWithSameId.length - 1].quantity > 1) {
        theme.cart.changeItem(itemsWithSameId[itemsWithSameId.length - 1].key, 1);
        document.dispatchEvent(new CustomEvent('cart:build'));
      }
      console.log("itemsWithSameId", itemsWithSameId);
      this.removeLink.setAttribute("href", `${theme.routes.cartChangeLink}?id=${itemsWithSameId[0].id}&quantity=0`)
      this.updateDateAttribute(itemsWithSameId[0].properties["Date"]);
      this.showDateInCart(itemsWithSameId[0].properties["Date"])
      document.dispatchEvent(new CustomEvent('cart:build'));

      return true; // Date Product is in cart
    }
    this.hideDateInCart();
    this.updateDateAttribute();

    return false;

  }
  // Function to add days to a date
  addDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }
}

customElements.define('delivery-calendar', DeliveryCalendar);
